import {
  API_REQUEST,
  DOWNLOAD_RESIDENTIAL_PROFILE,
  RESET_RESIDENTIAL_PROFILE,
} from "../../actionTypes/actionsTypes";
import { AppAction } from "../../types";

export const downloadResidentialProfilePdf = (
  userId: string,
  roll: string,
  language: string,
  html: string,
  ownerType?: string
): AppAction => ({
  type: API_REQUEST,
  payload: {
    url: `/documents/profile/${userId}/${roll}/${language}/${html}` + (ownerType ? `/${ownerType}` : ""),
    next: DOWNLOAD_RESIDENTIAL_PROFILE,
    method: "POST",
    authorization: true,
  },
});

export const downloadResidentialProfilePdfPoi = (
  userId: string,
  roll: string,
  language: string,
  ownerType: string,
  poiRoll: string,
  html: string
): AppAction => {
  const data = downloadResidentialProfilePdf(userId, roll, language, html, ownerType);
  data["payload"]["data"] = {
    o_type: ownerType,
    poi_roll: poiRoll,
  };
  return data;
};

export const resetResidentialProfile = (): AppAction => ({
  type: RESET_RESIDENTIAL_PROFILE,
  payload: {},
});
